import { useEffect, useRef } from 'react';
export function useTimeout(callback, { delay, enabled = true }) {
    const savedCallback = useRef(undefined);
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        function tick() {
            var _a;
            (_a = savedCallback.current) === null || _a === void 0 ? void 0 : _a.call(savedCallback);
        }
        if (!enabled) {
            return;
        }
        const id = setTimeout(tick, delay);
        return () => clearTimeout(id);
    }, [delay, enabled]);
}
